import { type FC } from 'react';

import styles from './Logo.module.css';

interface LogoProps {
  className?: string;
}

/*
  ПРОБА «Концепция 2»: монограмма из двух «П»-опор со скошенным верхом (рост вверх) + надпись РПСО.
  Нарисовано вручную по эскизу владельца — геометрия приблизительная, не финальный знак.
  Скос крыш одинаковый (наклон −0,5), чтобы опоры читались одной системой.
*/
const Mark = () => (
  <svg viewBox="0 0 46 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* левая опора-«Г» и внутренняя стойка — цвет бренда */}
    <polygon className={styles.markMain} points="2,46 2,18 22,8 22,14 9,20.5 9,46" />
    <polygon className={styles.markInner} points="13,46 13,21.5 19,18.5 19,46" />
    {/* правая «П» — выше и впереди, цветом текста */}
    <polygon className={styles.markFront} points="24,46 24,14 44,4 44,46 38,46 38,13 30,17 30,46" />
  </svg>
);

// Надпись штрихами, а не шрифтом: широкий гротеск из эскиза не совпадает ни с Oswald, ни с Roboto Condensed
const Wordmark = () => (
  <svg viewBox="0 0 126 34" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g fill="none" stroke="currentColor" strokeWidth="7">
      <path d="M3.5 34V3.5H16.5A7 7 0 0 1 16.5 17.5H3.5" />
      <path d="M36.5 34V3.5H56.5V34" />
      <path d="M93 3.5H77.5A8 8 0 0 0 69.5 11.5V22.5A8 8 0 0 0 77.5 30.5H93" />
      <rect x="102.5" y="3.5" width="20" height="27" rx="8" />
    </g>
  </svg>
);

/**
 * Имя ссылки-логотипа «на главную». Содержит видимую подпись знака: голосовой ввод находит
 * ссылку по тому, что видно на экране (WCAG 2.5.3); «РПСО» нарисовано SVG и для скринридера скрыто
 */
export const LOGO_HOME_LABEL =
  'РПСО, российский производитель спортивного оборудования — на главную';

export const Logo: FC<LogoProps> = ({ className }) => (
  <div className={[styles.wrapper, className].filter(Boolean).join(' ')}>
    <div className={styles.mark}>
      <Mark />
    </div>
    <div className={styles.text}>
      <div className={styles.wordmark}>
        <Wordmark />
      </div>
      <span className={styles.tagline}>
        Российский производитель
        <br />
        спортивного оборудования
      </span>
    </div>
  </div>
);
